<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<main class="favorites-shell">
<div class="favorites-page">
  <div class="fav-head">
    <div>
      <h1>My favorites</h1>
      <p class="lede">Items you've saved to come back to.</p>
    </div>
    @if (!loading && !loadError && favorites.length) {
      <span class="fav-count">{{ favorites.length }} saved</span>
    }
  </div>

  @if (loading) {
    <div class="fav-grid" aria-busy="true" aria-label="Loading your favorites">
      @for (s of skeletons; track s) {
        <div class="fav-card fav-card--skeleton">
          <span class="fav-skel fav-skel--cover"></span>
          <div class="fav-body">
            <span class="fav-skel fav-skel--title"></span>
            <span class="fav-skel fav-skel--line"></span>
            <span class="fav-skel fav-skel--btn"></span>
          </div>
        </div>
      }
    </div>
  } @else if (loadError) {
    <div class="fav-empty">
      <span class="fav-empty-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><line x1="12" y1="7.5" x2="12" y2="12.5" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
      </span>
      @if (loadError === 'signin') {
        <h3>Please sign in again</h3>
        <p>Your sign-in has expired, so we couldn't load your favorites.</p>
        <a routerLink="/login" class="wt-btn-primary">Sign in</a>
      } @else {
        <h3>Couldn't load your favorites</h3>
        <p>Check your connection and try again.</p>
        <button type="button" class="wt-btn-primary" (click)="load()">Try again</button>
      }
    </div>
  } @else if (favorites.length === 0) {
    <div class="fav-empty">
      <span class="fav-empty-icon fav-empty-icon--heart" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
      </span>
      <h3>No favorites yet</h3>
      <p>Tap the heart on anything in the store to save it here.</p>
      <a routerLink="/store" class="wt-btn-primary">Browse the store</a>
    </div>
  } @else {
    <div class="fav-grid">
      @for (fav of favorites; track fav.id) {
        <article class="fav-card" [class.is-removing]="removingId === fav.id">
          <a class="fav-cover" [routerLink]="['/marketplace/listing', fav.listing_detail.id]">
            @if (fav.listing_detail.cover_image) {
              <img [src]="fav.listing_detail.cover_image" alt="" loading="lazy" />
            }
            @if (fav.listing_detail.category_detail) {
              <span class="fav-type">{{ fav.listing_detail.category_detail.name }}</span>
            }
            <span class="fav-price" [class.is-free]="!(+fav.listing_detail.price)">{{ price(fav.listing_detail) }}</span>
          </a>
          <button
            type="button"
            class="fav-heart"
            [disabled]="removingId === fav.id"
            (click)="remove(fav)"
            aria-label="Remove from favorites"
            title="Remove from favorites"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
          </button>

          <div class="fav-body">
            <a class="fav-title" [routerLink]="['/marketplace/listing', fav.listing_detail.id]" [title]="fav.listing_detail.title">{{ fav.listing_detail.title }}</a>
            <a class="fav-shop" [routerLink]="['/store']" [queryParams]="{ author: fav.listing_detail.vendor.shop_slug }">{{ fav.listing_detail.vendor.shop_name }}</a>

            <div class="fav-action">
              @if (fav.listing_detail.is_mine) {
                <span class="fav-state">Your item</span>
              } @else if (fav.listing_detail.is_owned) {
                <a class="fav-state is-owned" routerLink="/marketplace/orders">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  Owned — download
                </a>
              } @else if (!(+fav.listing_detail.price)) {
                <button type="button" class="fav-btn" [disabled]="busyListingId === fav.listing_detail.id" (click)="claimFree(fav.listing_detail)">
                  {{ busyListingId === fav.listing_detail.id ? 'Getting…' : 'Get for free' }}
                </button>
              } @else {
                <button type="button" class="fav-btn" [disabled]="busyListingId === fav.listing_detail.id" (click)="addToCart(fav.listing_detail)">
                  {{ busyListingId === fav.listing_detail.id ? 'Adding…' : 'Add to cart' }}
                </button>
              }
            </div>
          </div>
        </article>
      }
    </div>
  }
</div>
</main>
<app-footer></app-footer>
